import { Base } from "ui/Scripts/source/framework/base";
import { IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { CalendarTaskPrivacyFilter } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";

export const CalendarTaskStateFilterAll = -1;
export const CalendarTaskHandlersFilterAll = "";
export const CalendarTaskCategoryNotSetId = "00000000-0000-0000-0000-000000000001";

export const CalendarTaskReminderOptions = [
    { value: "", label: Translations.ReminderNone },
    { value: "0", label: `0 ${Translations.ReminderMinutesBefore}` },
    { value: "10", label: `10 ${Translations.ReminderMinutesBefore}` },
    { value: "15", label: `15 ${Translations.ReminderMinutesBefore}` },
    { value: "30", label: `30 ${Translations.ReminderMinutesBefore}` },
    { value: "60", label: `1 ${Translations.ReminderHourBefore}` },
    { value: "120", label: `2 ${Translations.ReminderHoursBefore}` },
    { value: "180", label: `3 ${Translations.ReminderHoursBefore}` },
    { value: "240", label: `4 ${Translations.ReminderHoursBefore}` },
    { value: "300", label: `5 ${Translations.ReminderHoursBefore}` },
    { value: "600", label: `10 ${Translations.ReminderHoursBefore}` },
    { value: "1440", label: `1 ${Translations.ReminderDayBefore}` },
    { value: "2880", label: `2 ${Translations.ReminderDaysBefore}` },
    { value: "4320", label: `3 ${Translations.ReminderDaysBefore}` },
    { value: "5760", label: `4 ${Translations.ReminderDaysBefore}` },
    { value: "10080", label: `1 ${Translations.ReminderWeekBefore}` },
    { value: "20160", label: `2 ${Translations.ReminderWeekBefore}` },
];

export const GetCalendarTaskReminderTitle = (value: string): string => {
    const option = CalendarTaskReminderOptions.find(option => option.value === value);
    return option ? option.label : "";
};

export interface ICalendarTaskPageFilterLists {
    categories: IIdColorTitle[];
    states: IIdTitle[];
    handlers: IIdTitle[];
    creators: IIdTitle[];
    privacy: IIdTitle[];
}

export interface ICalendarTaskPageFilterState {
    selectedCategoryIds: string[];
    selectedStateIds: string[];
    selectedHandlerUserGroupCodes: string[];
    selectedCreateUserCodes: string[];
    selectedPrivacy: string;
}

export interface ICalendarTaskPageGeneralFilter {
    categoryIds: string[];
    states: number[];
    handlerUserGroupCodes: string[];
    createUserCodes: string[];
    privacy: number;
}

export interface ICalendarTaskPageGeneralFilterChange extends ICalendarTaskPageGeneralFilter {
    notChanged: boolean;
}

export const getCalendarTaskPageGeneralFilterFromFilterState = (state: ICalendarTaskPageFilterState): ICalendarTaskPageGeneralFilter => {
    return {
        categoryIds: state?.selectedCategoryIds?.filter(i => i !== Base.emptyGuid) ?? [],
        states: state?.selectedStateIds?.filter(i => i !== CalendarTaskStateFilterAll.toString(10)).map(i => i.toInteger()) ?? [],
        handlerUserGroupCodes: state?.selectedHandlerUserGroupCodes?.filter(i => !!i) ?? [],
        createUserCodes: state?.selectedCreateUserCodes?.filter(i => !!i) ?? [],
        privacy: state?.selectedPrivacy.toInteger(false, CalendarTaskPrivacyFilter.All),
    };
};

export const getCalendarTaskPageFilterStateFromGeneralFilter = (generalFilter: any): ICalendarTaskPageFilterState => {
    return {
        selectedCategoryIds: generalFilter?.categoryIds?.length > 0 ? generalFilter.categoryIds : [Base.emptyGuid],
        selectedStateIds: generalFilter?.states?.length > 0 ? generalFilter.states.map(i => i.toString(10)) : [CalendarTaskStateFilterAll.toString(10)],
        selectedHandlerUserGroupCodes: generalFilter?.handlerUserGroupCodes?.length ? generalFilter.handlerUserGroupCodes : [CalendarTaskHandlersFilterAll],
        selectedCreateUserCodes: generalFilter?.createUserCodes?.length ? generalFilter.createUserCodes : [CalendarTaskHandlersFilterAll],
        selectedPrivacy: (generalFilter?.privacy ?? CalendarTaskPrivacyFilter.All).toString(10)
    };
};

export const getCalendarTaskPageGeneralFilterNotChanged = (prevFilter: ICalendarTaskPageGeneralFilter, filter: ICalendarTaskPageGeneralFilter): boolean => {
    return Base.equalStrArrays(prevFilter.categoryIds, filter.categoryIds) &&
        Base.equalStrArrays(prevFilter.states.map(i => i.toString(10)), filter.states.map(i => i.toString(10))) &&
        Base.equalStrArrays(prevFilter.handlerUserGroupCodes, filter.handlerUserGroupCodes) &&
        Base.equalStrArrays(prevFilter.createUserCodes, filter.createUserCodes) &&
        prevFilter.privacy.toString(10) === filter.privacy.toString(10);
};

export const getCalendarTaskPageGeneralFilterChange = (prevProps: ICalendarTaskPageFilterState, props: ICalendarTaskPageFilterState): ICalendarTaskPageGeneralFilterChange => {
    const prevFilter = getCalendarTaskPageGeneralFilterFromFilterState(prevProps);
    const filter = getCalendarTaskPageGeneralFilterFromFilterState(props);
    return {
        ...filter,
        notChanged: getCalendarTaskPageGeneralFilterNotChanged(prevFilter, filter)
    };
};
